<template>
  <form @submit.prevent="filter">
    <div class="my-form-row">
      <div class="my-form-col">
        <label for="name">Nome</label>
        <fg-input
          id="name"
          name="name"
          class="w-100 m-0"
          type="text"
          v-model="name"
        >
        </fg-input>
      </div>
      <div class="my-form-col">
        <label for="brand">Marca</label>
        <fg-input
          id="brand"
          name="brand"
          class="w-100 m-0"
          type="text"
          v-model="brand"
        >
        </fg-input>
      </div>
    </div>
    <div class="row text-center d-flex justify-content-center">
      <button type="submit" class="btn btn-sm btn-primary">Filtrar</button>
    </div>
  </form>
</template>

<script>
export default {
  name: "filterProducts",
  data() {
    return {
      name: null,
      brand: null,
    };
  },
  methods: {
    filter() {
      this.$emit("handleRead", {
        url_filter: true,
        url_params: this.computed_form,
      });
    },
  },
  computed: {
    computed_form() {
      let form = {};
      if (!!this.name) {
        form.name = this.name;
      }
      if (!!this.brand) {
        form.brand = this.brand;
      }
      return Object.keys(form).length ? form : null;
    },
  },
};
</script>

<style></style>
